import { render } from "./WaterMarks.vue?vue&type=template&id=533d48a0"
import script from "./WaterMarks.vue?vue&type=script&lang=js"
export * from "./WaterMarks.vue?vue&type=script&lang=js"
script.render = render

export default script